import { Component, input, computed } from '@angular/core';
import { MessagesModule } from 'primeng/messages';
import { DateService } from '../services/date.service';

@Component({
  selector: 'nfp-effective-date-gap-warning',
  standalone: true,
  imports: [MessagesModule],
  template: `
    @if (showWarningMessage()) {
      <div class="mt-2"><p-messages [value]="warningMessages" [closable]="false"></p-messages></div>
    }
  `,
  styles: [ ]
})
export class NfpEffectiveDateGapWarningComponent {

  carrierEffectiveDate = input.required<string | Date>();
  policyEffectiveDate = input.required<string | Date>();
  showWarningMessage =  computed(() => 
      {
          return this.effectiveDateGap();
      }    
    );

  readonly warningMessages = [
    {
      severity: 'warn',
      summary: 'The requested policy effective date and the CAB effective filing date indicate that this submission may be considered a mid-term move. After appropriate review of loss run documents and filings, the submission may be declined if Underwriter classified it as a mid-term move. Please review before completing the submission.'
    }
  ];

  constructor(private dateService: DateService) { }

  private effectiveDateGap(): boolean {
    const carrier = this.dateService.getCorrectDate(this.carrierEffectiveDate());
    const policy = this.dateService.getCorrectDate(this.policyEffectiveDate());

    if (!carrier || !policy) return false;

    const expectedPolicyDate = new Date(carrier);
    expectedPolicyDate.setFullYear(expectedPolicyDate.getFullYear() + 1);

    return expectedPolicyDate.getTime() !== policy.getTime();
  }

}